<template>
  <div>
    <v-chip v-for="tag in tags" :key="tag" class="mr-1 mb-1">{{ tag }}</v-chip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Prop } from 'vue/types/options'

export default defineComponent({
  name: 'JobTagsDisplay',

  props: {
    tags: Array as Prop<string[]>,
  },
})
</script>

<style scoped></style>
